import { useEffect, useId } from 'react';

export default function useEnterSubmit() {
  const id = useId();
  useEffect(() => {
    const keyEnter = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const button = document.getElementById(id);
        if (button && !button.disabled) {
          button.focus();
          // Delay for 100ms to allow validation to run
          setTimeout(() => button.click(), 100);
        }
      }
    };
    document.addEventListener('keydown', keyEnter);

    return () => {
      document.removeEventListener('keydown', keyEnter);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return id;
}
